import * as React from "react"
import { cn } from "@/lib/utils"

interface TooltipProps {
  content: string
  side?: 'right' | 'top' | 'bottom' | 'left'
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

export function Tooltip({ content, side = 'right', children, className, disabled }: TooltipProps) {
  if (disabled) return <>{children}</>
  return (
    <div className={cn("relative group/tip", className)}>
      {children}
      <div
        className={cn(
          "pointer-events-none absolute z-50 px-2 py-1 text-xs font-medium rounded-md",
          "bg-foreground text-background whitespace-nowrap shadow-md",
          "opacity-0 group-hover/tip:opacity-100 transition-opacity duration-150",
          side === 'right' && "left-full ml-2.5 top-1/2 -translate-y-1/2",
          side === 'left'  && "right-full mr-2.5 top-1/2 -translate-y-1/2",
          side === 'top'   && "bottom-full mb-2 left-1/2 -translate-x-1/2",
          side === 'bottom'&& "top-full mt-2 left-1/2 -translate-x-1/2",
        )}
      >
        {content}
      </div>
    </div>
  )
}
